import React from 'react';
import './Home.css';
import Product from '../Product/Product';
import products from '../../assets/js/products';
import picBreak from '../../assets/images/amazon_clone_pic_break.jpg';
import Footer from '../../components/Footer/Footer';

function Home() {
  return (
    <div className="home">
      <img
        className="home__image"
        src="https://images-eu.ssl-images-amazon.com/images/G/02/digital/video/merch2016/Hero/Covid19/Generic/GWBleedingHero_ENG_COVIDUPDATE__XSite_1500x600_PV_en-GB._CB428684220_.jpg"
        alt="Amazon.com"
      />
      <div className="home__products">
        <img className="home__transparentImage" src={picBreak} alt="" />
        {products?.map((productsRow, index) => (
          <div className="home__row" key={index}>
            {productsRow[0] && (
              <Product
                id={productsRow[0].id}
                title={productsRow[0].title}
                price={productsRow[0].price}
                rating={productsRow[0].rating}
                image={productsRow[0].image}
                description={productsRow[0].description}
                category={productsRow[0].category}
              />
            )}
            {productsRow[1] && (
              <Product
                id={productsRow[1].id}
                title={productsRow[1].title}
                price={productsRow[1].price}
                rating={productsRow[1].rating}
                image={productsRow[1].image}
                description={productsRow[1].description}
                category={productsRow[1].category}
              />
            )}
            {productsRow[2] && (
              <Product
                id={productsRow[2].id}
                title={productsRow[2].title}
                price={productsRow[2].price}
                rating={productsRow[2].rating}
                image={productsRow[2].image}
                description={productsRow[2].description}
                category={productsRow[2].category}
              />
            )}
          </div>
        ))}
        <Footer />
      </div>
    </div>
  );
}

export default Home;
